<tt-page *ngIf="!!menu">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="operation_name" [ttModel]="menu.operation_name" ttReadonly></tt-input>
        <tt-input ttLabel="calctime_text_pr_unit" [ttModel]="menu.calctime_hours_pr_unit" ttReadonly></tt-input>
        <tt-input ttLabel="calctime_text" [ttModel]="menu.calctime_hours" ttReadonly></tt-input>
        <tt-input ttLabel="actualtime_text" [ttModel]="menu.actualtime_hours" ttReadonly></tt-input>
        <tt-input ttLabel="cost_pr_hour" [ttModel]="menu.cost_pr_hour" ttReadonly></tt-input>
        <tt-input ttLabel="actualtime_method" [ttModel]="menu.actualtime_method" ttReadonly></tt-input>
        <tt-button-save ttText="save"></tt-button-save>
    </tt-card>
</tt-page>
